import { useAppSelector } from '@store';
import useCurrencies from '../hooks/use-currencies';
import { AccountCurrenciesTypes } from '../types';
import { IconArrowLeft } from '../../../../../../baseella-ui-components/src';
import AccountCurrenciesComponent from '../../../../components/common/accounts/currencies';
import AccountCurrenciesPopup from '../../../../components/common/accounts/currencies-popup';

import cn from '../styles.module.css';

const AccountCurrencies = ({
  setShowCurrencies,
  setSelectedAccount,
  accounts,
  selectedAccount,
  status,
}: AccountCurrenciesTypes) => {
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const {
    balances,
    setBlockPopupVisible,
    setSelectedBlockCurrency,
    setEnablePopupVisible,
    setSelectedEnableCurrency,
    isLoading,
    isFetching,
    selectedBlockCurrency,
    setError,
    blockPopupVisible,
    error,
    disableInProgress,
    onDisableBalanceAction,
    selectedEnableCurrency,
    enablePopupVisible,
    enableInProgress,
    onEnableBalanceAction,
  } = useCurrencies({
    selectedAccount,
  });

  return (
    <div className={cn.availableCurrencies}>
      <button
        type="button"
        className={cn.backButton}
        onClick={() => {
          setShowCurrencies(false);
          setSelectedAccount('');
        }}
      >
        <IconArrowLeft width={13} height={11} />
        Back to Accounts
      </button>
      <div className={cn.availableCurrenciesTitle}>Available Currencies</div>
      <AccountCurrenciesComponent
        accounts={accounts}
        selectedAccount={selectedAccount}
        setSelectedAccount={setSelectedAccount}
        currenciesList={currenciesList}
        balances={balances}
        setBlockPopupVisible={setBlockPopupVisible}
        setSelectedBlockCurrency={setSelectedBlockCurrency}
        setEnablePopupVisible={setEnablePopupVisible}
        setSelectedEnableCurrency={setSelectedEnableCurrency}
        status={status}
        isLoading={isLoading}
        isFetching={isFetching}
      />
      <AccountCurrenciesPopup
        currenciesList={currenciesList}
        selectedBlockCurrency={selectedBlockCurrency}
        setBlockPopupVisible={setBlockPopupVisible}
        setSelectedBlockCurrency={setSelectedBlockCurrency}
        setError={setError}
        blockPopupVisible={blockPopupVisible}
        error={error}
        disableInProgress={disableInProgress}
        onDisableBalanceAction={onDisableBalanceAction}
        selectedEnableCurrency={selectedEnableCurrency}
        setEnablePopupVisible={setEnablePopupVisible}
        setSelectedEnableCurrency={setSelectedEnableCurrency}
        enablePopupVisible={enablePopupVisible}
        enableInProgress={enableInProgress}
        onEnableBalanceAction={onEnableBalanceAction}
      />
    </div>
  );
};

export default AccountCurrencies;
